import Platform from "../../../libs/utility/Platform";
import { Theme } from "../constants";

export default {
    pageBody: { 
        overflow: 'auto',
        flex: 1,
        backgroundColor: Theme.BACKGROUND_PRIMARY, 
        padding: Platform.isMobileView() ? "10px" : '30px',
        display: "flex",
        flexDirection: "column",
    },
}